import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { ThemeProvider } from '@mui/material';
import {
  Login,
  JoinInterpreter,
  ThankYou,
  LoginSelectorPage,
} from '../../pages';
import { ThemeMode } from 'utils/contexts/theme-mode.context';
import Redirect from 'pages/Redirect/Redirect.page';
import PrivateLayout from 'shared/components/layout/private-layout.component';
import PublicLayout from 'shared/components/layout/public-layout.component';
import RequestLocation from 'pages/LocationSelector/location-select.component';

export default function AppRouter() {
  const { theme } = useContext(ThemeMode);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<PrivateLayout />}>
            <Route index element={<JoinInterpreter />} />
            <Route path='/thankyou' element={<ThankYou />} />
            <Route path='/location' element={<RequestLocation />} />
          </Route>
          <Route path='/login' element={<PublicLayout />}>
            <Route index element={<LoginSelectorPage />} />
            <Route path='vrs' element={<Login />} />
          </Route>
          <Route path='/redirect' element={<Redirect />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
